(function($) {
  "use strict";
  $(function() {
    var quotes = ajax.footer_quotes;

    var randomQuoteKey = Math.floor(Math.random() * quotes.length);

    let $quoteNumber = $(".js-quote-number");
    let $quoteText = $(".js-quote-text");

    $quoteNumber.text(quotes[randomQuoteKey]["footer_quote_number"]);
    $quoteText.text(quotes[randomQuoteKey]["footer_quote_text"]);
  });
})(jQuery);
